<template>
  <v-progress-circular
    :rotate="-90"
    :size="60"
    :width="8"
    :value="percent"
    color="#ffc545"
  >
    <span class="subtitle-2">
      <animated-int :value="average" :decimals="2"/>
    </span>
  </v-progress-circular>
</template>
<script>
import AnimatedInt from './AnimatedInt'

export default {
  components: {AnimatedInt},
  props: {
    average: {
      required: true
    }
  },
  computed: {
    percent () {
      return (this.average / 5 ) * 100
    }
  }
}
</script>
<style lang="scss">
  .v-progress-circular {
    &__info {
      color: #000;
    }
  }
</style>
